var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-form-group',{attrs:{"label":_vm.label}},[_c('b-form-radio-group',{key:_vm.id,attrs:{"id":_vm.id,"name":_vm.id,"disabled":_vm.checkDisabled,"options":_vm.options},on:{"change":function($event){return _vm.onChange()}},model:{value:(_vm.valueCheckbox),callback:function ($$v) {_vm.valueCheckbox=$$v},expression:"valueCheckbox"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }